<template>

    <div class="absolute overflow-hidden rounded-b-lg shadow-xl canvas::editor-website-FloatingPanel" 
        :style="{ width: width + 'px' }"
        :class="{
            [className]: true,
        }"
    >

        <div class="flex items-center text-white rounded-t-lg cursor-move heading top"
            draggable="true"
        >

            <div class="ml-5 mr-auto title">{{ title }}</div>

            <button class="mx-5 text-white" @click="close">
                <i class="fal fa-times"></i>
            </button>

        </div>

        <div class="bg-white rounded-b-lg content">
            <!--@scroll="onScroll"-->

            <!--
            <input
                type="text"
                v-model="query"
                class="searchInput bg-[#f1f5f9] focus:bg-gray-100 border-0 px-5 py-2 text-sm text-gray-600 w-full focus:ring-0"
                ref="search"
                placeholder="Filter instellingen..."
            >
            -->

            <div class="scroller">
                <slot/>

                <div class="p-5 text-gray-400" v-if="query && !searchResults.length">
                    Geen zoekresultaten gevonden
                </div>
            </div>

            <div class="sticky bottom-0 border-t actions -mt-[1px]" v-if="$slots['actions'] || $slots['actionsExtra'] || saveable">
                <!--
                <div v-show="!isOnBottomOfPage" class="absolute top-0 -mt-6 transform -translate-x-1/2 left-1/2 animate-bounce">
                    <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
                    </svg>
                </div>
                -->

                <slot name="actions"/>

                <div class="flex defaultActions" v-if="!$slots['actions']">

                    <slot name="actionsExtra"/>

                    <button v-if="saveable" class="btn btn-success" @click="save">
                        <i class="mr-2 fas fa-check"></i> Opslaan
                    </button>

                    <button v-if="saveable" class="inline-flex items-center justify-center w-full px-4 py-3 text-white rounded-none bg-amber-400 focus:ring-2 focus:ring-amber-500 focus:z-10 hover:bg-amber-500 ring-offset-2"
                            @click="close"
                    >
                        <i class="mr-2 fas fa-times"></i> Annuleren
                    </button>

                </div>

            </div>

        </div>

    </div>

</template>

<script>

export default {

    inject: [
        '$pageComponent',
        'options',
    ],

    props: {
        className: {
            type: String,
            default: '',
        },
        title: {
            type: String,
            default: 'Instellingen',
        },
        width: {
            type: Number,
            default: 400,
        },
        saveable: {
            type: Boolean,
            default: true,
        },
    },

    data() {
        return {
            isOnBottomOfPage: false,

            query: '',
            resultBeforeSearch: [],

            searchParams: [
                'isOpen',
                'panelSearching'
            ],

            nodeResult: [],
            searchResults: [],
        }
    },

    mounted() {
        const resizeObserver = new ResizeObserver(() => {
            // Get vue element of parent of the FloatingPanel and update position
            const parent = this.$el.parentElement;
        
            if (parent) {
                const parentVue = parent.__vue__;
                if (parentVue && parentVue.position) {
                    parentVue.position();
                }
            }
            
        });

        resizeObserver.observe(this.$el);
    },

    watch: {
        query(newQuery, oldQuery) {
            this.nodeResult = [];
            this.searchResults = [];

            this.searchForTextWithinChildren(this.$slots.default, newQuery);
            this.applySearchedStyling();

            if (newQuery === '') {
                this.resetSearchQuery();
            }
        }
    },

    // created()
    // {
    //     this.$nextTick(() => {
    //         this.$refs.search.focus();
    //     });
    // },

    methods: {
        applySearchedStyling() {
            this.resultBeforeSearch = {...this.nodeResult};

            for (const key in this.nodeResult) {
                $(this.nodeResult[key].$el).css('display', 'none');
            }

            for (const key in this.searchResults) {
                $(this.searchResults[key].$el).css('display', 'block');
            }
        },

        resetSearchQuery() {
            this.resetPanelSearching(this.$slots.default);

            // Open first accordion (basically reset how FloatingPanel opens)
            let firstNodeAccordion = this.nodeResult.find((node) => {
                return Object.hasOwn(node, 'isOpen');
            });

            if( firstNodeAccordion ) {
                firstNodeAccordion.isOpen = true;
            }
        },

        nodeHasSearchOptions(node, active = true, options = {})
        {
            this.searchParams.forEach((searchParam) => {
                // Check if node has given parameter and set a value for it
                if ((options[searchParam] || true) && Object.hasOwn(node, searchParam)) {
                    node[searchParam] = active;
                }
            });
        },

        resetPanelSearching(children) {
            return children.filter((node) => {
                // Check if node has context which then includes children?
                if (node.context && node.context.$children) {
                    this.resetPanelSearching(node.context.$children);
                }

                if (node.$children) {
                    this.resetPanelSearching(node.$children);
                }

                // Undo node type set as being searched from FloatingPanel; except for is open, we retrieve this later
                this.nodeHasSearchOptions(node, false, {'isOpen': false});

                return true;
            });
        },

        searchForTextWithinChildren(children, query) {
            return children.filter((node) => {
                // Check if node has context which then includes children?
                if (node.context && node.context.$children) {
                    this.searchForTextWithinChildren(node.context.$children, query);
                }

                if (node.$children) {
                    this.searchForTextWithinChildren(node.$children, query);
                }

                // Set node type as being searched from FloatingPanel
                this.nodeHasSearchOptions(node, true);

                let text = ((node.text || (node.$el ? node.$el.textContent : '')) + ''),
                    findText = this.fuzzySearch(query, text);

                // Don't search in children or search result, so we can only show the correct nodes
                if (this.nodeHasNoChildren(node)) {
                    this.nodeResult.push(node);

                    if (findText[0]) {
                        this.searchResults.push(node);
                    }
                }

                return findText;
            });
        },

        nodeHasNoChildren(node)
        {
            return !(node.context && node.context.$children.length)
                && !node.$children.length
        },

        // Returns [bool, score, formattedStr]
        // bool: true if each character in pattern is found sequentially within str
        // score: integer; higher is better match. Value has no intrinsic meaning. Range varies with pattern.
        //        Can only compare scores with same search pattern.
        // formattedStr: input str with matched characters marked in <b> tags. Delete if unwanted.
        fuzzySearch(pattern, str) {
            // Score consts
            var adjacency_bonus = 5;                // bonus for adjacent matches
            var separator_bonus = 10;               // bonus if match occurs after a separator
            var camel_bonus = 10;                   // bonus if match is uppercase and prev is lower
            var leading_letter_penalty = -3;        // penalty applied for every letter in str before the first match
            var max_leading_letter_penalty = -9;    // maximum penalty for leading letters
            var unmatched_letter_penalty = -1;      // penalty for every letter that doesn't matter

            // Loop variables
            var score = 0;
            var patternIdx = 0;
            var patternLength = pattern.length;
            var strIdx = 0;
            var strLength = str.length;
            var prevMatched = false;
            var prevLower = false;
            var prevSeparator = true;       // true so if first letter match gets separator bonus

            // Use "best" matched letter if multiple string letters match the pattern
            var bestLetter = null;
            var bestLower = null;
            var bestLetterIdx = null;
            var bestLetterScore = 0;

            var matchedIndices = [];

            // Loop over strings
            while (strIdx != strLength) {
                var patternChar = patternIdx != patternLength ? pattern.charAt(patternIdx) : null;
                var strChar = str.charAt(strIdx);

                var patternLower = patternChar != null ? patternChar.toLowerCase() : null;
                var strLower = strChar.toLowerCase();
                var strUpper = strChar.toUpperCase();

                var nextMatch = patternChar && patternLower == strLower;
                var rematch = bestLetter && bestLower == strLower;

                var advanced = nextMatch && bestLetter;
                var patternRepeat = bestLetter && patternChar && bestLower == patternLower;
                if (advanced || patternRepeat) {
                    score += bestLetterScore;
                    matchedIndices.push(bestLetterIdx);
                    bestLetter = null;
                    bestLower = null;
                    bestLetterIdx = null;
                    bestLetterScore = 0;
                }

                if (nextMatch || rematch) {
                    var newScore = 0;

                    // Apply penalty for each letter before the first pattern match
                    // Note: std::max because penalties are negative values. So max is smallest penalty.
                    if (patternIdx == 0) {
                        var penalty = Math.max(strIdx * leading_letter_penalty, max_leading_letter_penalty);
                        score += penalty;
                    }

                    // Apply bonus for consecutive bonuses
                    if (prevMatched)
                        newScore += adjacency_bonus;

                    // Apply bonus for matches after a separator
                    if (prevSeparator)
                        newScore += separator_bonus;

                    // Apply bonus across camel case boundaries. Includes "clever" isLetter check.
                    if (prevLower && strChar == strUpper && strLower != strUpper)
                        newScore += camel_bonus;

                    // Update patter index IFF the next pattern letter was matched
                    if (nextMatch)
                        ++patternIdx;

                    // Update best letter in str which may be for a "next" letter or a "rematch"
                    if (newScore >= bestLetterScore) {

                        // Apply penalty for now skipped letter
                        if (bestLetter != null)
                            score += unmatched_letter_penalty;

                        bestLetter = strChar;
                        bestLower = bestLetter.toLowerCase();
                        bestLetterIdx = strIdx;
                        bestLetterScore = newScore;
                    }

                    prevMatched = true;
                } else {
                    // Append unmatch characters
                    formattedStr += strChar;

                    score += unmatched_letter_penalty;
                    prevMatched = false;
                }

                // Includes "clever" isLetter check.
                prevLower = strChar == strLower && strLower != strUpper;
                prevSeparator = strChar == '_' || strChar == ' ';

                ++strIdx;
            }

            // Apply score for last match
            if (bestLetter) {
                score += bestLetterScore;
                matchedIndices.push(bestLetterIdx);
            }

            // Finish out formatted string after last pattern matched
            // Build formated string based on matched letters
            var formattedStr = "";
            var lastIdx = 0;
            for (var i = 0; i < matchedIndices.length; ++i) {
                var idx = matchedIndices[i];
                formattedStr += str.substr(lastIdx, idx - lastIdx) + "<b>" + str.charAt(idx) + "</b>";
                lastIdx = idx + 1;
            }
            formattedStr += str.substr(lastIdx, str.length - lastIdx);

            var matched = patternIdx == patternLength;
            return [matched, score, formattedStr];
        },

        onScroll({target: {scrollTop, clientHeight, scrollHeight}}) {
            this.isOnBottomOfPage = scrollTop + clientHeight >= scrollHeight;
        },

        close() {
            this.$pageComponent().selection.setSelection(null);
        },

        save() {
            // Close after save.
            this.$pageComponent().state.$once('newHtml', html => this.close());

            // @ugly We assume AbstractPanel is above us.
            this.$parent.save();
        },

    },

}

</script>

<style lang="scss" scoped>

.canvas\:\:editor-website-FloatingPanel {
    left: 25px;
    top: 25px;

    .top {
        @apply bg-indigo-500;
        padding-bottom: 10px;
        padding-top: 10px;

        // Needed since a block css targets .title
        .title {
            font-size: 1rem;
        }

        .close2 {
            background: hsl(243deg 75% 59%);
            outline: none !important;
        }
    }

    .searchInput {
        &::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
            @apply text-gray-600;
            opacity: 1; /* Firefox */
        }

        &:-ms-input-placeholder { /* Internet Explorer 10-11 */
            @apply text-gray-600;
        }

        &::-ms-input-placeholder { /* Microsoft Edge */
            @apply text-gray-600;
        }
    }

    .content {
        .scroller {

            max-height: calc(80vh - 50px);
            overflow-y: auto;

            &::-webkit-scrollbar {
                width: 7px;
            }

            /* Track */
            &::-webkit-scrollbar-track {
                // ..
            }

            &:hover::-webkit-scrollbar-thumb {
                @apply bg-gray-300;
            }

            /* Handle */
            &::-webkit-scrollbar-thumb {
                @apply bg-gray-100 rounded transition;
            }

            &::v-deep {

                // TODO Right place?
                input::placeholder {
                    opacity: .5;
                }

            }

        }

        .defaultActions {
            button {
                @apply w-full rounded-none inline-flex justify-center focus:z-10;
            }
        }
    }

}


</style>

<style lang="scss">
.canvas\:\:editor-website-FloatingPanel {
    

    .avatar-cropper {
        .avatar-cropper-overlay {
            position: absolute;
        }
    }
    
}
</style>